// Access the strings used on the createPassword page.
export const t_createPassword = {
  title: "signup.createPassword.title",
  subtitle: "signup.createPassword.subtitle",
  passwordPlaceholder: "signup.createPassword.passwordPlaceholder",
  confirmPasswordPlaceholder:
    "signup.createPassword.confirmPasswordPlaceholder",
};
